import * as React from 'react'

export const SUPPORT_EMAIL = 'support@noduslabs.com'

// After two failed attempts the buyer is offered a person, not another retry.
export default function PaymentError({ error, attempts }) {
    if (!error) return null
    return (
        <p
            className="tw-m-0 tw-text-sm tw-text-destructive"
            role="alert"
            data-testid="payment-error"
        >
            {error}
            {attempts >= 2 ? (
                <>
                    {' '}
                    Still failing? <a href={`mailto:${SUPPORT_EMAIL}`}>
                        Contact us
                    </a>{' '}
                    and we'll sort it out.
                </>
            ) : null}
        </p>
    )
}
